export default function currencyFormat(num) {
    return num.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
 }